module.exports = __webpack_public_path__ + "static/media/mypic.ae39df88.jpeg";